// Same payload retains its key after a timeout; a successful save starts a new action.
export function createResponseRequestKeys() {
  const pending = new Map();
  return {
    get(scope, payload) {
      const fingerprint = JSON.stringify([scope, payload]);
      if (!pending.has(fingerprint)) pending.set(fingerprint, crypto.randomUUID());
      return { key: pending.get(fingerprint), fingerprint };
    },
    complete(fingerprint) { pending.delete(fingerprint); },
  };
}
